var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 667,
    viewBox: "0 0 375 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2009_3262)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    fill: "url(#paint0_linear_2009_3262)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2009_3262)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.0475,
    cy: 536.31,
    rx: 163,
    ry: 162.5,
    transform: "rotate(15 88.0475 536.31)",
    fill: "url(#paint1_radial_2009_3262)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2009_3262)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 227.679,
    cy: 635.323,
    rx: 156.5,
    ry: 158,
    transform: "rotate(15 227.679 635.323)",
    fill: "url(#paint2_radial_2009_3262)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2009_3262)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264.982,
    cy: 515.982,
    r: 169,
    transform: "rotate(15 264.982 515.982)",
    fill: "url(#paint3_radial_2009_3262)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2009_3262",
    x: -153.959,
    y: 294.736,
    width: 484.014,
    height: 483.148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39.5,
    result: "effect1_foregroundBlur_2009_3262"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2009_3262",
    x: -21.5612,
    y: 384.784,
    width: 498.48,
    height: 501.078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 46.3,
    result: "effect1_foregroundBlur_2009_3262"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2009_3262",
    x: 3.33994,
    y: 254.34,
    width: 523.284,
    height: 523.284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 46.3,
    result: "effect1_foregroundBlur_2009_3262"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2009_3262",
    x1: 187.5,
    y1: 0,
    x2: 187.5,
    y2: 667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22142D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301D3E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2009_3262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.0475 536.31) rotate(90) scale(162.5 163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2009_3262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.679 635.323) rotate(90) scale(158 156.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14EAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14EAB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2009_3262",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(264.982 515.982) rotate(90) scale(169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC6CF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6CF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2009_3262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.d98930a08bb0cf757c505ffa9ac7ca73.svg";
export { ForwardRef as ReactComponent };